import styled from 'styled-components';

export const CustomModal = styled.div`
    &.forget-modal{
        .modal-body {
            padding: 0 20px 20px;
        }
    }
`;
export const ModalTitle = styled.h4` 
    margin-bottom: 8px !important;
    color: #083F44;
    font-family: "Jost", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
     
`;
export const ModalText = styled.p `
    max-width: 234px;
    width: 100%;
    margin: 0 auto;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
`;
export const ForgetPasswordForm = styled.div`
    margin-top: 20px;

    .forget-password-form {
        .form-group {
            .input-group {
                background: #F2F2F2;
                border-radius: 10px;

                input {
                    background: transparent;
                    padding: 14px 5px 14px 20px;
                    font-family: "Jost", sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    border-radius: 10px;
                    border: none;
                }
                .input-group-text {
                    background: transparent;
                    border: none;
                }
            }
        }
    }
`;
export const FormSubmitBtn = styled.div`

    margin-top: 13px;

    &.forget-password-submit{
        .btn-outline-success-blue{
            &.btn-primary{
                width: 100%;
                background: #01606F;
                box-shadow: 0px 3px 20px #0000001A;
                border-radius: 8px;
                color: #fff;
                border: none;
            }
        }
    }
`;